export const FETCH_STATISTIC_RANGE = '[STATISTIC]FETCH_STATISTIC_RANGE';
export const FETCH_STAFF_STATISTIC_RANGE = '[STATISTIC]FETCH_STAFF_STATISTIC_RANGE';

export const FETCH_GIFTS_STATISTIC = '[STATISTIC]FETCH_GIFTS_STATISTIC';
